const selectors = {
  productContainer: document.querySelector('.product-details-wrapper'),
  productMedia: document.querySelector('[data-productMedia]')
};

const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
window.productMedia = mediaJSON;
class TemplateProductJS {
  constructor() {
    this.reviewCustomization();
    this.stickyThumbnails();
  }

  stickyThumbnails(){
    let headerHeight = document.querySelector('header').clientHeight;
    document.querySelector('[  data-productSticky]').style.top = `${headerHeight}px`
  }

  reviewCustomization(){
    let reviewInterval = setInterval(() => {
      if(document.querySelector('.spr-badge-caption')){
        let review = document.querySelector('.spr-badge-caption').innerHTML;
        if( review != "No reviews" ){
          review = review.replace('review','');
          document.querySelector('.spr-badge-caption').innerHTML = review;
        }
      }
      document.querySelector('.spr-badge-caption') ? clearInterval(reviewInterval) : '';
    }, 2000);
  }
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();

class RechargeSubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
  }

  connectedCallback() {
    this._setDefaultPurchaseType();
    this._bindEvents();
    this._syncSellingPlan();
  }

  _isMobile() {
    return window.matchMedia('(max-width: 991px)').matches;
  }

  _setDefaultPurchaseType() {
    const defaultType = 'onetime';

    this.querySelectorAll('input[name="selling_plan"]').forEach(radio => {
      radio.checked = radio.dataset.purchaseType === defaultType;
    });

    this.querySelectorAll('.widget-options').forEach(el => {
      el.classList.toggle('selected', el.dataset.purchaseType === defaultType);
    });
  }

  _bindEvents() {
    this.querySelectorAll('input[name="selling_plan"]').forEach(radio => {
      radio.addEventListener('change', (e) => this._onPurchaseTypeChange(e));
    });

    this.querySelectorAll('.selling-plan-radio').forEach(radio => {
      radio.addEventListener('change', (e) => this._onPlanRadioChange(e));
    });

    const select = this.querySelector('[data-selling-plan-select]');
    if (select) {
      select.addEventListener('change', (e) => this._onPlanSelectChange(e));
    }
  }

  _onPurchaseTypeChange(e) {
    const type = e.target.dataset.purchaseType;
    const isSubscription = type === 'subscription';

    this.querySelectorAll('.widget-options').forEach(el => {
      el.classList.toggle('selected', el.dataset.purchaseType === type);
    });

    if (isSubscription) {
      this._syncSellingPlan();
    } else {
      this._updateHiddenSellingPlan('');
    }
  }

  _onPlanRadioChange(e) {
    const planId = e.target.value;

    this._setSellingPlanValue(planId);
    this._syncMobileSelect(planId);
  }

  _onPlanSelectChange(e) {
    const planId = e.target.value;

    this._setSellingPlanValue(planId);
    this._syncDesktopRadio(planId);
  }

  _syncSellingPlan() {
    const checkedRadio = this.querySelector('.selling-plan-radio:checked');
    const select = this.querySelector('[data-selling-plan-select]');
    const planId = checkedRadio?.value || select?.value;

    const purchaseTypeInput = this.querySelector('input[name="selling_plan"]:checked');
    const isSubscription = purchaseTypeInput?.dataset.purchaseType === 'subscription';

    if (planId && isSubscription) this._setSellingPlanValue(planId);
  }

  _setSellingPlanValue(planId) {
    const subscriptionRadio = this.querySelector('input[name="selling_plan"][data-purchase-type="subscription"]');
    if (subscriptionRadio) {
      subscriptionRadio.value = planId;
    }

    const purchaseTypeInput = this.querySelector('input[name="selling_plan"]:checked');
    const isSubscription = purchaseTypeInput?.dataset.purchaseType === 'subscription';
    if (isSubscription) {
      this._updateHiddenSellingPlan(planId);
    }

    this.dispatchEvent(new CustomEvent('selling-plan-changed', {
      bubbles: true,
      detail: { planId, productId: this.productId }
    }));
  }

  _syncMobileSelect(planId) {
    const select = this.querySelector('[data-selling-plan-select]');
    if (select) select.value = planId;
  }

  _syncDesktopRadio(planId) {
    const radio = this.querySelector(`.selling-plan-radio[value="${planId}"]`);
    if (radio) radio.checked = true;
  }

  _updateHiddenSellingPlan(planId) {
    let hidden = this.closest('form')?.querySelector('input[name="selling_plan"][type="hidden"]');
    if (hidden) hidden.value = planId;
  }
}

customElements.define('recharge-subscription-widget-aw', RechargeSubscriptionWidget);

class RcAwLearnMore extends HTMLElement {
  connectedCallback() {
    this.setAttribute('role', 'button');
    this.setAttribute('tabindex', '0');
    this.style.cursor = 'pointer';

    this.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const widget = this.closest('recharge-subscription-widget-aw');
      const modal = widget?.querySelector('rc-aw-learn-more-modal')
        ?? document.querySelector('rc-aw-learn-more-modal');

      modal?.open();
    });

    this.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  }
}

class RcAwLearnMoreModal extends HTMLElement {
  connectedCallback() {
    this._render();
    this._bindEvents();
  }

  _render() {
    const existingContent = this.innerHTML;
    this.innerHTML = `
      <div class="rc-aw-modal-overlay" data-modal-overlay>
        <div class="rc-aw-modal-dialog" role="dialog" aria-modal="true">
          <button type="button" class="rc-aw-modal-close" data-modal-close aria-label="Close">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L15 15M15 1L1 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </button>
          <div class="rc-aw-modal-body">
            ${existingContent}
          </div>
        </div>
      </div>
    `;
  }

  _bindEvents() {
    this.querySelector('[data-modal-close]')?.addEventListener('click', () => this.close());

    this.querySelector('[data-modal-overlay]')?.addEventListener('click', (e) => {
      if (e.target === e.currentTarget) this.close();
    });

    this._onKeydown = (e) => {
      if (e.key === 'Escape') this.close();
    };
  }

  open() {
    this.classList.remove('d-none');
    this.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this._onKeydown);

    this.querySelector('.rc-aw-modal-dialog')?.focus();
  }

  close() {
    this.classList.add('d-none');
    this.classList.remove('is-open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this._onKeydown);
  }
}

customElements.define('rc-aw-learn-more', RcAwLearnMore);
customElements.define('rc-aw-learn-more-modal', RcAwLearnMoreModal);